import { CoverageLevel, SkinTone, fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import { SessionStorage } from '../../session';
import { SetAvatarDisplayPayload, homeActions } from '../slices/homeSlice';
import { HomeDispatch } from '../store/homeStore';

/**
 * Keep names compatible with UpdateAvatarTexturesPayload
 */
type UpdateAvatarDisplayPayload = {
  coverageBottom?: CoverageLevel;
  coverageTop?: CoverageLevel;
  skin?: SkinTone;
};

/**
 * Update avatar coverage.
 * @param dispatch Redux dispatch function.
 * @param payload Coverage update.
 */
export function updateAvatarDisplay(dispatch: HomeDispatch, payload: UpdateAvatarDisplayPayload) {
  // Convert payload.
  const display: SetAvatarDisplayPayload = {};

  if (payload.coverageBottom) {
    display.avatarDisplayCovBottom = payload.coverageBottom;
  }
  if (payload.coverageTop) {
    display.avatarDisplayCovTop = payload.coverageTop;
  }
  if (payload.skin) {
    display.avatarDisplaySkin = payload.skin;
  }

  // Update state.
  dispatch(homeActions.setAvatarDisplay(display));

  // Update cache.
  SessionStorage.pushData(display);

  // Update visualization.
  const context = fitroomViewportModuleContext();
  context.updateAvatarTextures(payload);
}
